import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';
import Header from 'src/conponents/Shared/Header';
import TelegramWidget from 'src/conponents/Shared/TelegramWidget';
import ContactForm from 'src/conponents/Shared/ContactForm';

function GuestLayout({ children }) {
  return (
    <div className="guest-layout">
      <Header />
      {children}
      <TelegramWidget />
      <ContactForm />
    </div>
  );
}

GuestLayout.propTypes = {
  children: PropTypes.element,
};

export default GuestLayout;
